import { AnalyticsContextValue } from "@swiggy-private/checkout-core";

import { IMPRESSION_ACTIONS, SCREEN_NAME } from "../constants";

export interface CartLoadMetadata {
    prefetchEnabled: boolean;
    prefetchBridgeUsed: boolean;
    source: "prefetch" | "bau";
    bgRefreshNeeded: boolean;
    bgRefreshReason: string | null;
    isRemount: boolean;
    prefetchFallbackReason: string | null;
    hasActiveTimers: boolean;
    prefetchTimestamp: number | null;
    cacheTtlMs: number | null;
}

export const impressionCartLoad = ({
    impressionEvent,
    metadata,
    cartId,
    restaurantId,
    groupCartId,
}: {
    impressionEvent: AnalyticsContextValue["impressionEvent"];
    metadata: CartLoadMetadata | null;
    cartId: string | number | undefined;
    restaurantId: string | number | undefined;
    groupCartId: string | undefined;
}): void => {
    if (!metadata) {
        return;
    }

    impressionEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: IMPRESSION_ACTIONS.IMPRESSION_CART_LOAD,
        label: String(restaurantId ?? "--"),
        context: JSON.stringify({ ...metadata, cartId: String(cartId ?? "--") }),
        // eslint-disable-next-line @typescript-eslint/naming-convention
        extraParams: JSON.stringify({ grp_cart_id: groupCartId }),
    });

    if (typeof window !== "undefined") {
        window.__cartImpressionFired__ = "true";
    }
};
